import React, { useEffect, useMemo } from 'react';
import {
  NavigationContainer,
  useNavigationContainerRef,
  createNavigationContainerRef
} from '@react-navigation/native';
import { Platform, SafeAreaView  , StatusBar } from 'react-native';
import AppRoutes from './navigationApp';
import InterceptorSetup from './api/interceptor';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './lang/i18n';
import { ThemeProvider } from '@shopify/restyle';
import createDynamicTheme from './theme';
import { getParameters, StoreKey } from '@voltmoney/micro-frontend';
import { useAppSelector } from './store/hooks'
import AsyncStorage from '@react-native-async-storage/async-storage';
import LogOutUser from './helper/logout';
import { isIframeCheck, useDarkMode } from './utils';
// import {navigationRef} from './utils/utils';


InterceptorSetup();
const NewApp = ({ extraProps }) => {
  const { routingSupport, setRoutingSupport, setIsUserLoggedIn } = extraProps;
  const navigationRef = useNavigationContainerRef();
  const auth = useAppSelector(state => state.auth);

  const isDarkMode = useDarkMode();
  let primaryColor = null;
  if(Platform.OS === 'web'){
    primaryColor = getParameters(window?.location?.href).primaryColor;
  }

  const theme = useMemo(
    () => createDynamicTheme('core', isDarkMode ? 'dark' : 'light',primaryColor),
    [],
  );

  return (
    <ThemeProvider theme={theme}>
      <SafeAreaView style={{ flex: 1 }}>
        <NavigationContainer
          ref={navigationRef}
          onUnhandledAction={async (action: any) => {
            setIsUserLoggedIn(auth?.userDetails);
            console.log(
              'Unhandled action',
              action.payload.name,
              action.payload.params,
            );
            let accessToken = null
            if(Platform.OS === 'web'){
              const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
              if(isAccessTokenInCookiPreset){
                const accessTokenCookie = document.cookie.split(';').find((item) => item.trim().startsWith('access_token='));
                accessToken = accessTokenCookie?.split('=')[1];
              }
              if(!isAccessTokenInCookiPreset && isIframeCheck()){
                accessToken = await AsyncStorage.getItem('access_token');
                if(Boolean(accessToken)){
               }
              }
            }else{
             accessToken = await AsyncStorage.getItem(StoreKey.accessToken);
            }
            if(accessToken){
            setRoutingSupport({
              renderNewArch: false,
              routeName: 'SPLASH_SCREEN',
              params: action.payload.params,
            });
          }
          else{
            LogOutUser()
          }
          }}
        >
          <I18nextProvider i18n={i18n}>
            <StatusBar
              barStyle="default"
            />
            <AppRoutes setIsUserLoggedIn={setIsUserLoggedIn}/>
          </I18nextProvider>
        </NavigationContainer>
      </SafeAreaView>
    </ThemeProvider>
  );
};
export default NewApp;
